module.exports = __webpack_public_path__ + "img/thumbnail_CaliforniaSeaLion_j_albino.d134f64a.png";